<template>
    <DsCard
        class="template-gallery-html-card"
        :disabled="selected || disabled"
    >
        <header v-if="showHeader" class="template-card-header">
            <slot name="preTitleContent" />

            <div class="title" :title="template.name">
                {{ template.name }}
            </div>

            <div v-if="$slots.menu" ref="menu" class="menu">
                <slot name="menu" />
            </div>
        </header>

        <div>
            <iframe
                class="card-html-frame"
                scrolling="no"
                :srcdoc="previewHtml"
                sandbox="allow-scripts"
                frameborder="0"
                loading="lazy"
            />

            <div v-if="selected" class="template-overlay">
                <DsSpinner />
            </div>

            <div v-else class="template-overlay template-details">
                <slot name="overlay" />
            </div>
        </div>
    </DsCard>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true,
        },

        showHeader: {
            type: Boolean,
            default: true,
        },

        selected: Boolean,

        disabled: Boolean,

    },

    computed: {
        previewHtml() {
            return this.template?.htmlPreviewUrl ? this.previewHtmlFromImageUrl : this.template.html;
        },

        previewHtmlFromImageUrl() {
            return `<html><body><img style="width: 100%" src="${this.template.htmlPreviewUrl}" /></body></html>`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import './variables';

.template-gallery-html-card {
    padding: 0;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
}

.template-overlay {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba($color-paper, .7);
}

.template-card-header {
    background: $color-paper;
    color: $color-ink-900;
    border-bottom: 1px solid $color-ink-100;
    min-height: px-to-rem(48);
    padding: px-to-rem(12);
    z-index: 3;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
}

.template-gallery-html-card:not(:hover) .template-details {
    display: none;
}

.title {
    font-weight: 700;
    line-height: $line-height-sm;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
}

.menu {
    flex: 0;
    width: 2rem;
    margin: px-to-rem(-6) 0;
    margin-left: auto;
}

.card-html-frame {
    height: $card-size * 2;
    width: $card-size * 2;
    transform: scale(.5);
    transform-origin: 0 0;
}
</style>
